module.exports = __webpack_public_path__ + "img/btn_google_light_normal.1cdc8fce.svg";